<template>
  <div class="contents">
    <personnel-team/>
    <emergency-plan/>
  </div>
</template>

<script>

export default {
  components: {
    personnelTeam: () => import('./personnelTeam'),
    emergencyPlan: () => import('./emergencyPlan')
  },
  mounted() {}
};
</script>

<style scoped lang="less">
.contents{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/emergencyDisposal/index.vue